import { createRouter, createWebHashHistory } from 'vue-router'
import { computed } from 'vue'
import NProgress from 'nprogress'
import { useUserStore, useNavlistStore } from '@/store'
import 'nprogress/nprogress.css'
import { ElNotification } from 'element-plus'
import { beforeEach, afterEach } from './scrollBehavior'
import C from '@/config'
import { getNavList } from '@/utils/function'

const routes = [{
    name: 'layout',
    path: '/',
    component: () => import('@/layout'),
    redirect: C.DashboardUrl || '/store/index/index',
    children: []
}, {
    path: '/store/public/login',
    name: 'public_login',
    component: () => import('@/views/store/public/login'),
    meta: { title: '登陆', icon: 'el-icon-location' }
}]
const router = createRouter({
    history: createWebHashHistory(),
    routes
})
// 系统特殊路由
const routes_404 = {
    path: '/:pathMatch(.*)*',
    hidden: true,
    component: () => import('@/layout/other/404')
}
let routes_404_r = () => {}

NProgress.configure({ showSpinner: false })

// 判断是否已加载过动态/静态路由
var isGetRouter = false
const whiteList = ['/store/public/login']
router.beforeEach(async(to, from, next) => {
    NProgress.start()
    document.title = to.meta.title
    const StoreUser = useUserStore()
    const StoreNavlist = useNavlistStore()
    const hasToken = computed(() => StoreUser.isLogin)
    if (to.path === '/store/public/login') {
        router.addRoute(routes[0])
        routes_404_r()
        isGetRouter = false
        next()
        return false
    }

    if (routes.findIndex(r => r.path === to.path) >= 0) {
        next()
        return false
    }
    if (!hasToken.value) {
        next({
            path: '/store/public/login'
        })
        return false
    }

    // 整页路由处理
    if (to.meta.fullpage) {
        to.matched = [to.matched[to.matched.length - 1]]
    }

    // 加载动态/静态路由
    if (!isGetRouter) {
        getNavList(StoreNavlist).then((res, rej) => {
            var menuRouter = filterAsyncRouter(res)
            menuRouter = flatAsyncRoutes(menuRouter)
            menuRouter.forEach(item => {
                router.addRoute('layout', item)
            })
            routes_404_r = router.addRoute(routes_404)
            if (to.matched.length === 0) {
                router.push(to.fullPath)
            }
            isGetRouter = true
        }).catch(() => {
        })
    }
    beforeEach(to, from)
    next()
})

router.onError((error) => {
    NProgress.done()
    ElNotification.error({
        title: '路由错误',
        message: error.message
    })
})

router.afterEach((to, from) => {
    afterEach(to, from)
    NProgress.done()
})
// 入侵追加自定义方法、对象
router.sc_getMenu = () => {
    const StoreNavlist = useNavlistStore()
    return StoreNavlist.list
}
// 转换
function filterAsyncRouter(routerMap) {
    const accessedRouters = []
    routerMap.forEach(item => {
        item.meta = item.meta ? item.meta : {}
        // 处理外部链接特殊路由
        if (item.meta.type === 'iframe') {
            item.meta.url = item.path
            item.path = `/i/${item.name}`
        }
        // MAP转路由对象
        var route = {
            path: item.path,
            name: item.name,
            meta: item.meta,
            redirect: item.redirect,
            children: item.children ? filterAsyncRouter(item.children) : null,
            component: loadComponent(item.component),
            hidden: item.hidden
        }
        accessedRouters.push(route)
    })
    return accessedRouters
}
function loadComponent(component) {
    if (component) {
        return () => import('@/views' + component)
    } else {
        return () => import('@/layout/other/empty')
    }
}

// 路由扁平化
function flatAsyncRoutes(routes, breadcrumb = []) {
    let res = []
    routes.forEach(route => {
        const tmp = { ...route }
        if (tmp.children) {
            let childrenBreadcrumb = [...breadcrumb]
            childrenBreadcrumb.push(route)
            let tmpRoute = { ...route }
            tmpRoute.meta.breadcrumb = childrenBreadcrumb
            delete tmpRoute.children
            res.push(tmpRoute)
            let childrenRoutes = flatAsyncRoutes(tmp.children, childrenBreadcrumb)
            childrenRoutes.map(item => {
                res.push(item)
            })
        } else {
            let tmpBreadcrumb = [...breadcrumb]
            tmpBreadcrumb.push(tmp)
            tmp.meta.breadcrumb = tmpBreadcrumb
            res.push(tmp)
        }
    })
    return res
}

export default router
